import { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import TimocomForm from "./Timocom";

import { useAdminGetIntegrationStatusQuery } from "../integrationsApiSlice";
// import { RemoveTransConnection } from "./Trans/RemoveTransConnection";
import { TransApiForm } from "./Trans/TransApiForm";

const UserIntegrations = ({ companyId }) => {
	const { data, isLoading } = useAdminGetIntegrationStatusQuery({
		companyId,
	});

	const [expanded, setExpanded] = useState({
		timocom: false,
		trans: false,
	});

	return (
		<>
			<Accordion
				expanded={expanded.timocom}
				onChange={() =>
					setExpanded({ ...expanded, timocom: !expanded.timocom })
				}
			>
				<AccordionSummary
					expandIcon={expanded.timocom ? <RemoveIcon /> : <AddIcon />}
					aria-controls="timocom-content"
					id="timocom-header"
				>
					<Typography sx={{ color: "#0069B4" }}>TIMOCOM</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{isLoading ? (
						<Skeleton variant="rectangular" height={138} width={882} />
					) : (
						<TimocomForm
							companyId={companyId}
							status={data?.timocomStatus}
							timocomCustomerRef={data?.timocomCustomerRef}
							timocomPrincipalName={data?.timocomPrincipalName}
							timocomPassword={data?.timocomPassword}
						/>
					)}
				</AccordionDetails>
			</Accordion>
			<Accordion
				expanded={expanded.trans}
				onChange={() => setExpanded({ ...expanded, trans: !expanded.trans })}
			>
				<AccordionSummary
					expandIcon={expanded.trans ? <RemoveIcon /> : <AddIcon />}
					aria-controls="trans-content"
					id="trans-header"
				>
					<Typography sx={{ color: "#0069B4" }}>TRANS</Typography>
				</AccordionSummary>
				<AccordionDetails>
					{isLoading ? (
						<Skeleton variant="rectangular" height={138} width={882} />
					) : (
						<>
							<TransApiForm
								companyId={companyId}
								status={data?.transStatus}
								defaultValues={{
									transClientId: data?.transClientId || "",
									transClientSecret: data?.transClientSecret || "",
									transApiKey: data?.transApiKey || "",
									transAuthType: data?.transAuthType || "",
								}}
							/>
							{/* <RemoveTransConnection /> */}
						</>
					)}
				</AccordionDetails>
			</Accordion>
		</>
	);
};

export default UserIntegrations;
